import * as effects from 'redux-saga/effects';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { profileActions } from '../../actions';
import { PayloadActionWithPromiseMeta } from '@core/FinalForm/typedefs';
import { IProfile } from '@bus/profile/typedefs';
import {
  FormErrors,
  getServerFormErrors,
  ServerFormErrors,
} from '@core/FinalForm/getServerErrors';
import { call, put } from 'redux-saga/effects';

export function* updateProfile({
  payload,
  meta: { resolve, reject },
}: PayloadActionWithPromiseMeta<Partial<IProfile>>) {
  try {
    yield effects.put(profileActions.startFetching());
    const body: string = yield effects.call(JSON.stringify, payload);
    const response: Response = yield effects.apply(api, api.patch, [
      { endpoint: 'users/', body },
    ]);

    const data: ServerFormErrors | IProfile = yield call([response, 'json']);
    if (!response.ok) {
      const formErrors: FormErrors = yield call(
        getServerFormErrors,
        data as ServerFormErrors,
      );
      reject(formErrors);
      yield throwError(response);
    }

    yield put(profileActions.fillProfile(data as IProfile));
    resolve();
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(profileActions.stopFetching());
  }
}
